import Axios from 'axios'

import { parseAuthenticationHeader } from 'helpers/Functions'
import { TCustomField } from 'types/GlobalCustomField'

const BASE_URL =
  process.env.NODE_ENV === 'development'
    ? 'http://localhost:3990/'
    : process.env.REACT_APP_HOMEPAL_MDM_API_PROD

const URL = `${BASE_URL}v1/custom-fields`

export async function getAll() {
  return Axios.get<{ data: TCustomField[] }>(URL, parseAuthenticationHeader())
}

export async function create(fieldName: string) {
  return Axios.post<{ data: TCustomField }>(
    URL,
    { data: { field_name: fieldName } },
    parseAuthenticationHeader()
  )
}
